import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
    selector: 'ca-restart-modal',
    template: `
    <h2 mat-dialog-title>An error has occurred</h2>
    <mat-dialog-content
      >An unexpected error has occurred and CareApp needs to reload. We apologise for this
      inconvenience. This error has been reported.</mat-dialog-content
    >
    <mat-dialog-actions>
      <button mat-button (click)="close()" mat-dialog-close>Reload CareApp</button>
    </mat-dialog-actions>
  `,
    standalone: false
})
export class RestartModalComponent {
  constructor(private ref: MatDialogRef<RestartModalComponent>) {}

  close() {
    console.log('close');
    this.ref.close();
  }
}
